import React from 'react';
import { Link } from 'gatsby';
import NumberedList, {
  NumberedListItem,
} from '../components/NumberedList/NumberedList';
import Content, { Heading } from '../components/Content';

function GettingStarted() {
  return (
    <Content as="article">
      <Heading>Getting started</Heading>

      <h2>PSD2 TPP Access and Related Documentation</h2>
      <p>
        {'Please note that licensed PSD2 TPPs are not required to apply for '}
        partner API access.
      </p>

      <p>
        {'Please visit our '}
        <Link as={Link} to="/documentation/psd2">
          PSD2 documentation
        </Link>
        .
      </p>

      <NumberedList>
        <NumberedListItem>
          <h3>Sign up</h3>
          <p>
            Sign up with your Github account by clicking &quot;Sign in&quot; in
            the upper right corner
          </p>
        </NumberedListItem>
        <NumberedListItem>
          <h3>Documentation access</h3>
          <p>
            API documentation can be found by navigating to{' '}
            <Link as={Link} to="/app/api">
              API Reference
            </Link>
            . Questions may be sent to{' '}
            <a
              href="mailto:developer@spv.no?Subject=Inquiry regarding PSD2 documentation"
              target="_top"
            >
              developer@spv.no
            </a>{' '}
          </p>
        </NumberedListItem>
      </NumberedList>

      <h2>General Partner and Developer Documentation Access</h2>
      <NumberedList>
        <NumberedListItem>
          <h3>Sign up</h3>
          <p>
            Register with your Github account by clicking &quot;Sign in&quot; in
            the upper right corner
          </p>
        </NumberedListItem>
        <NumberedListItem>
          <h3>Get documentation access</h3>
          <p>
            Request access to our API documentation by letting us now who you
            are, what APIs you need and why at{' '}
            <a
              href="mailto:developer@spv.no?Subject=Request for access to developer portal"
              target="_top"
            >
              developer@spv.no
            </a>
          </p>
        </NumberedListItem>
        <NumberedListItem>
          <h3>Explore our APIs</h3>
          <p>
            Get to know our APIs by exploring the{' '}
            <Link as={Link} to="/app/api">
              API Reference
            </Link>
          </p>
        </NumberedListItem>
        <NumberedListItem>
          <h3>Get access</h3>
          <p>
            Ready to start programming? Request access to our production
            environment by contacting us at{' '}
            <a
              href="mailto:developer@spv.no?Subject=Request for access to developer portal"
              target="_top"
            >
              developer@spv.no
            </a>
            <br />
          </p>
        </NumberedListItem>
      </NumberedList>
    </Content>
  );
}

export default GettingStarted;
